module.exports = __webpack_public_path__ + "static/img/Ilustra vistoria técnica.879caa3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/private/realestate/ocurrence/components/InfoSorting/PdfPictures/Ilustra vistoria técnica.svg
// module id = cgpZ
// module chunks = 0